import { render } from "./ValidationLabel.vue?vue&type=template&id=02b725d4&scoped=true&ts=true"
import script from "./ValidationLabel.vue?vue&type=script&lang=ts"
export * from "./ValidationLabel.vue?vue&type=script&lang=ts"

import "./ValidationLabel.vue?vue&type=style&index=0&id=02b725d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b725d4"]])

export default __exports__